import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { LocalStoreService } from '../../services/local-store.service';
import { RealtimeDatabaseService } from '../../services/realtime-database.service';
import { ToasterNotificationService } from '../../services/toaster-notification.service';
import { BellToasterNotificationService } from '../../services/bell-toaster-notification.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { TranslationService } from 'src/app/modules/core/services/translation.service';
import { SupabaseService } from '../../services/supabase.service';
import { UserService } from 'src/app/modules/account/shared/user.service';
import { RealTimeBalanceResponse } from 'src/types/balance';
import { Store } from '@ngrx/store';
import { selectUserDetailsData } from 'src/app/store/user-details/user-details.selectors';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [MessageService, DialogService],
})
export class HeaderComponent implements OnInit {
  @Output() toggleLeftSidenav = new EventEmitter();
  @Output() toggleRightSidenav = new EventEmitter();

  @Input() userBalance;
  @Input() username;

  classes: any;
  fluid = true;
  supabaseBalanceSubscription: Subscription;
  public balance: number;
  public timer: any;

  private userBalanceSubId: string;

  openedLeft = false;
  openedRight = false;
  ref: DynamicDialogRef;
  uid;
  isLogin = false;

  @ViewChild('myDrop', { static: true }) myDrop: NgbDropdown;

  constructor(
    public router: Router,
    public authService: AuthService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private rdService: RealtimeDatabaseService,
    private store: Store,
    private supabase: SupabaseService,
    private localStorageService: LocalStoreService,
    private translateService: TranslateService,
    private toasterNotificationService: ToasterNotificationService,
    private bellToasterNotificationService: BellToasterNotificationService,
    private translationService: TranslationService,
    private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    authService.event.subscribe((data) => {
      this.username = data;
    });
    this.getUserAccount();
  }

  ngOnInit(): void {
    const user = this.localStorageService.getItem('user');
    this.authService.currentAuthStatus.subscribe((authStatus) => {
      if (authStatus) {
        this.isLogin = true;
        //every 1 hour supabase token will be expired
        this.startListening();
        this.timer = setInterval(() => {
          this.startListening();
        }, 60 * 60 * 1000);
      } else {
        this.isLogin = false;
        this.stopListening();
        this.timer && clearInterval(this.timer);
      }
    });
  }

  ngAfterViewInit() {
    this.toasterNotificationService.receiveMessage((notification) => {
      const currentLanguage = this.translationService.getSelectedLanguage();
      const data = notification.notification[currentLanguage];
      const title = data.title;
      const body = data.body.replace('&#x2F;', '/');
      const templateType = notification.template.type;

      this.messageService.add({
        key: 'generic-toaster',
        severity: templateType,
        summary: title,
        detail: body,
        life: 30000,
      });
    });

    this.bellToasterNotificationService.receiveMessage((notification) => {
      const currentLanguage = this.translationService.getSelectedLanguage();
      const data = notification.notification[currentLanguage];
      const title = data.title;
      const bodyHtml = data.bodyHtml.replace('&#x2F;', '/');
      const body = data.body;
      const templateType = notification.template.name;

      this.messageService.add({
        severity: 'custom',
        key: 'bell-toaster',
        summary: title,
        detail: bodyHtml,
        life: 30000,
      });
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.stopListening();
  }

  closeDropdown(): any {
    this.myDrop.close();
  }

  toggleSidebar(isLeft): void {
    isLeft ? this.toggleLeftSidenav.emit() : this.toggleRightSidenav.emit();
  }

  login() {
    this.ref = this.dialogService.open(LoginPopupComponent, {
      showHeader: true,
      dismissableMask: true,
      closable: true,
      styleClass: 'login-modal',
      contentStyle: { 'border-radius': '4px', padding: '0', 'z-index': '999' },
    });
  }

  logOut() {
    this.authService.logOut();
    this.isLogin = false;
  }

  getUserAccount(): void {
    this.store.select(selectUserDetailsData).subscribe((user) => {
      if (user.balance && user.balance > 0) {
        this.balance = user.balance;
      } else {
        this.balance = 0;
      }
    });
    // this.userService.getUserAccount().subscribe((user) => {
    //   if (user.balance && user.balance > 0) {
    //     this.balance = user.balance;
    //   } else {
    //     this.balance = 0;
    //   }
    // });
  }

  startListening(): void {
    this.supabaseBalanceSubscription = this.supabase.getUserBalance(
      this.readBalance.bind(this)
    );
  }

  stopListening(): void {
    if (this.supabaseBalanceSubscription) {
      this.supabaseBalanceSubscription.unsubscribe();
    }
  }

  readBalance(data: RealTimeBalanceResponse): void {
    if (data.new) {
      this.balance = data.new.balance || 0;
      if (
        this.balance &&
        data.new.balance > this.balance &&
        data.new.notification
      ) {
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          life: 30000,
          detail: this.translateService.instant(
            'ALERT.MONEY_HAS_BEEN_DEPOSITED'
          ),
        });
      }
    }
  }
}
